<div
	#editable
	class="formula-editor form-control"
	contenteditable="true"
	(blur)="onBlur()"
	(keydown)="onKeyDown($event)"
	(paste)="onPaste($event)">
</div>
